import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { loadIndustrySectors } from '../../actions/common';
import { useAppSelector } from '../../reducers';
import { clearDropdownOption } from './ClearDropdownOption';
import { getIndustryOptions, getSectorOptions } from './utils';

export const useIndustrySector = (selectedSectorText: string | undefined) => {
  const dispatch = useDispatch();
  const industrySectors = useAppSelector((state) => state.industrySectors.data) || [];

  useEffect(() => {
    dispatch(loadIndustrySectors());
  }, [dispatch]);

  const sectorOptions = [clearDropdownOption('No Sector filter'), ...getSectorOptions(industrySectors)];
  const industryOptions = [
    clearDropdownOption('No Industry filter'),
    ...getIndustryOptions(industrySectors, selectedSectorText),
  ];

  return { sectorOptions, industryOptions}
}